var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form-item',{attrs:{"label":_vm.$t('宽度')}},[_c('el-input-number',{attrs:{"controls-position":"right","placeholder":_vm.$t('请输入'),"min":20},model:{value:(_vm.width),callback:function ($$v) {_vm.width=$$v},expression:"width"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }